/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileE57 = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M15.629 12.929h-1.95l-.13 1.078.024-.009a2.16 2.16 0 0 1 .697-.117c.34 0 .633.062.877.186.248.124.438.302.572.532.133.23.2.503.2.82 0 .337-.076.63-.228.884a1.532 1.532 0 0 1-.648.58 2.15 2.15 0 0 1-.973.207 3.98 3.98 0 0 1-.821-.083 2.594 2.594 0 0 1-.662-.228v-.918a3.16 3.16 0 0 0 1.407.325c.295 0 .527-.07.697-.207a.69.69 0 0 0 .255-.566c0-.23-.071-.41-.214-.538-.138-.129-.336-.193-.593-.193-.143 0-.295.018-.455.054a2.554 2.554 0 0 0-.462.153l-.608-.477.29-2.36h2.725zm-3.875-.034H9.566v1.118h1.988v.91H9.566v1.166h2.256V17H8.49v-5.017h3.264zm8.489-.125L18.511 17h-1.173l1.784-4.05h-1.504l-.294.773h-.635v-1.67h3.554z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileE57 as FileE57 };
